import {AnyAction} from "redux";
import {SET_MAP_OFFSET} from "../../actions/action";

export interface Point
{
    x: number;
    y: number;
}

export const getMapOffset = (state) => state.mapOffset;


/**
 * set the offset of the map
 */
export function mapOffset(state: Point = { x: -1730, y: -2890 }, action: AnyAction) : Point
{
    switch (action.type)
    {
        case SET_MAP_OFFSET:
        {
            const {payload} = action;
            const {ox:x, oy:y} = payload;

            return {x, y};
        }

        default:

            return state;
    }
}



// WEBPACK FOOTER //
// ./src/ts/store/reducers/map/mapOffset.ts